<template>
  <router-view />
</template>
<style>
@import url(assets/bw.css);
@import url(assets/style.css);
</style>